import * as Yup from "yup";

export const discountValidationSchema = Yup.object().shape({
  FromValue: Yup.number().required("From Value is required"),
  ToValue: Yup.number()
    .required("To Value is required")
    .min(
      Yup.ref("FromValue"),
      "To Value must be at least the same as From Value",
    ),
  DiscountPercent: Yup.number()
    .required("Discount Percent is required")
    .positive("Discount Percent must be a positive number"),
  IsActive: Yup.boolean().required("Status is required"),
});
